<template>
  <div class="hom-page">
    <Header />
    <div class="home-content">
      <div class="lunbo">
        <el-carousel height="580px">
          <el-carousel-item
            ><el-image style="width: 100%;" src="img/lun1.jpg" fit="cover"></el-image
          ></el-carousel-item>
          <el-carousel-item
            ><el-image src="img/lun2.png" fit="fill"></el-image
          ></el-carousel-item>
        </el-carousel>
      </div>
      <div class="advtop">
        <div class="advtop-content">
          <div class="advtop-item line">
            <div class="advtop-title">
              <span v-if="language === 'ch'">关于我们</span
              ><span v-else>About US</span>
            </div>
            <div class="advtop-conten">
              <div class="advtop-conten-left">
                <img src="img/sabout.jpg" />
              </div>
              <div class="advtop-conten-right">
                <div v-if="language === 'ch'">
                  美事来手袋厂有限公司于2002年在香港和深圳成立，是一家专业设计生产各种时款袋和银包的香港独资企业，现有员工1000多人，月生产能力20万只。公司产品内销和外销...
                </div>
                <div v-else>
                  The company was founded in 2002 in Hongkong and Shenzhen, is a
                  professional design and production of various types of bags
                  and ...
                </div>
              </div>
            </div>
            <div class="advtop-more"><a href="/about">More>>></a></div>
          </div>
          <div class="advtop-item line">
            <div class="advtop-title">
              <span v-if="language === 'ch'">联系我们</span
              ><span v-else>Contact US</span>
            </div>
            <div class="advtop-conten">
              <div class="advtop-info">
                <span class="advtop-info-item" v-if="language === 'ch'"
                  >深圳市美事来手袋有限公司</span
                >
                <span class="advtop-info-item" v-else
                  >MSL HANDBAG FACTORY LIMITED</span
                >
                <span class="advtop-info-item"
                  ><span v-if="language === 'ch'">电话:</span
                  ><span v-else>TEL:</span> 0755-84012262 / 84012686</span
                >
                <span class="advtop-info-item">
                  <span v-if="language === 'ch'">传真:</span
                  ><span v-else>FAX:</span> 0755-84012100</span
                >
                <span class="advtop-info-item"
                  ><span v-if="language === 'ch'">邮箱:</span
                  ><span v-else>E-MAIL:</span>lawrence_chan@msl-bag.com</span
                >
              </div>
            </div>
            <div class="advtop-more"><a href="/contactUs">More>>></a></div>
          </div>
          <div class="advtop-item">
            <div class="advtop-title">
              <span v-if="language === 'ch'">生产设备</span
              ><span v-else>Production Equipment</span>
            </div>
            <div class="test">
              <el-carousel height="150px">
                <el-carousel-item
                  ><el-image
                    style="height: 100px"
                    src="img/Equipment1.jpg"
                    fit="fill"
                  ></el-image
                ></el-carousel-item>
                <el-carousel-item
                  ><el-image
                    style=" height: 100px"
                    src="img/Equipment2.jpg"
                    fit="fill"
                  ></el-image
                ></el-carousel-item>
                <el-carousel-item
                  ><el-image src="img/Equipment3.jpg" fit="fill"></el-image
                ></el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
      <div class="product-list">
        <div class="image-container">
          <div class="image-wrapper">
            <img v-for="(item, index) in imgList" :key="index" class="my-lun-img"  :src="item.img" alt="image1" @click="showImagePreview(item.img)" />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      language: "",
      imgList: [
        {
          img: require('../assets/rotationChart/2.jpg'),
        },
        {
          img: require('../assets/rotationChart/3.jpg'),
        },
        {
          img: require('../assets/rotationChart/4.jpg'),
        },
        {
          img: require('../assets/rotationChart/5.jpg'),
        },
        {
          img: require('../assets/rotationChart/7.jpg'),
        },
        {
          img: require('../assets/rotationChart/10.jpg'),
        },
        {
          img: require('../assets/rotationChart/11.jpg'),
        },
        {
          img: require('../assets/rotationChart/12.jpg'),
        },
        {
          img: require('../assets/rotationChart/13.jpg'),
        },

        {
          img: require('../assets/rotationChart/14.jpg'),
        },
        {
          img: require('../assets/rotationChart/15.jpg'),
        },
        {
          img: require('../assets/rotationChart/17.jpg'),
        },
        {
          img: require('../assets/rotationChart/18.jpg'),
        },
        {
          img: require('../assets/rotationChart/19.jpg'),
        },
        {
          img: require('../assets/rotationChart/20.jpg'),
        },
      
        {
          img: require('../assets/rotationChart/21.jpg'),
        },
        {
          img: require('../assets/rotationChart/22.jpg'),
        },
        {
          img: require('../assets/rotationChart/23.jpg'),
        },
        {
          img: require('../assets/rotationChart/24.jpg'),
        },
        {
          img: require('../assets/rotationChart/25.jpg'),
        },
        {
          img: require('../assets/rotationChart/26.jpg'),
        },
        {
          img: require('../assets/rotationChart/27.jpg'),
        },
        {
          img: require('../assets/rotationChart/28.jpg'),
        },
      ]
    
    };
  },
  methods: {
    showImagePreview(img) {
      const image = new Image();
      image.src = img;
      image.onload = () => {
        // 创建弹出层
        const previewContainer = document.createElement('div');
        previewContainer.style.position = 'fixed';
        previewContainer.style.zIndex = 99999;
        previewContainer.style.top = 0;
        previewContainer.style.bottom = 0;
        previewContainer.style.left = 0;
        previewContainer.style.right = 0;
        previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
        previewContainer.style.display = 'flex';
        previewContainer.style.justifyContent = 'center';
        previewContainer.style.alignItems = 'center';
        document.body.appendChild(previewContainer);
        // 在弹出层中添加图片
        const previewImage = document.createElement('img');
        previewImage.src = img;
        previewImage.style.maxWidth = '80%';
        previewImage.style.maxHeight = '80%';
        previewContainer.appendChild(previewImage);
        // 点击弹出层，关闭预览
        previewContainer.addEventListener('click', () => {
          document.body.removeChild(previewContainer);
        });
      };
    }
  },
  created() {},
  mounted() {
    this.language = localStorage.getItem("curlanguage");
  },
};
</script>

<style scoped>
.hom-page {
  height: 100%;
  width: 100%;
}
.image-container {
  width: 100%;
  overflow: hidden;
}

.image-wrapper {
  display: flex;
  animation: scroll 30s linear infinite;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.my-lun-img {
  height: 200px;
  margin-right: 10px;
}
a {
  text-decoration: none;
}
.home-content {
  width: 1130px;
  margin: 0 auto;
  height: 1100px
}
.lunbo {
  margin: 12px 0;
}
.advtop {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.advtop-content {
  display: flex;
  flex-direction: row;
  width: 1130px;
  justify-content: space-between;
  font-size: 12px;
  border: 1px solid #cccccc;
}

.advtop-item {
  width: 346px;
  height: 166px;
  margin: 12px;
}

.advtop-title {
  font-size: 14px;
  margin-bottom: 12px;
}

.advtop-conten {
  display: flex;
  flex-direction: row;
}

.advtop-conten-right {
  margin-left: 12px;
  color: #9f9f9f;
  padding-right: 12px;
}

.advtop-more {
  float: right;
  padding-right: 12px;
}

.line {
  border-right: 1px dashed #9f9f9f;
  height: 166px;
}

.advtop-info {
  display: flex;
  flex-direction: column;
}

.advtop-info-item {
  line-height: 25px;
  color: #9f9f9f;
}
.product-list {
  margin-top: 24px;
}
</style>
